import { render } from "./EmailSettingAccountNotSynced.vue?vue&type=template&id=0108a2bf&scoped=true"
import script from "./EmailSettingAccountNotSynced.vue?vue&type=script&lang=js"
export * from "./EmailSettingAccountNotSynced.vue?vue&type=script&lang=js"

import "./EmailSettingAccountNotSynced.vue?vue&type=style&index=0&id=0108a2bf&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0108a2bf"]])

export default __exports__